var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utilTimer.ts
var UtilTimer = class {
  /**
   * delay
   * @param func
   * @param milliseconds
   */
  static delay(_0) {
    return __async(this, arguments, function* (func, milliseconds = 0 /* DEFAULT */) {
      let timer;
      return new Promise((_resolve, _reject) => timer = setTimeout(() => _resolve(func()), milliseconds)).finally(() => clearTimeout(timer));
    });
  }
};

// src/index.ts
var src_default = UtilTimer;
export {
  src_default as default
};
